module.exports = __webpack_public_path__ + "img/map2.ec768388.png";